module.exports = __webpack_public_path__ + "static/media/sass.515644bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/sass.png
// module id = 184
// module chunks = 0